// import React from "react";
// import { motion, useReducedMotion } from "framer-motion";
// import {
//   Zap,
//   CheckCircle2,
//   Clock,
//   Activity,
//   GitMerge,
//   Settings,
// } from "lucide-react";

// // Images remain untouched
// import Workflow1 from "../assets/CrmAutomated.jpeg";
// import Workflow2 from "../assets/crmautomated2.jpg";

// // Static content lives outside the component so it isn't rebuilt on every render
// const STATS = [
//   { icon: Clock, title: "Accelerate Response", text: "Engage prospects instantly" },
//   { icon: Activity, title: "Maximize ROI", text: "Boost overall conversion rates" },
// ];

// const CHECKLIST = [
//   "Omnichannel lead capture and intelligent organization",
//   "Automated, performance-based lead routing",
//   "Comprehensive interaction logging & journey tracking",
//   "Advanced analytics to identify funnel drop-offs",
//   "Real-time team collaboration and performance insights",
// ];

// const fadeUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
// };

// const stagger = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
// };

// // Small pill used above each sub-heading
// const Pill = ({ icon: Icon, children }) => (
//   <div className="inline-flex items-center gap-1.5 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-semibold text-[#48247f] shadow-sm">
//     <Icon className="h-3 w-3 text-[#702cb0]" />
//     {children}
//   </div>
// );

// // Heading with a gradient-highlighted phrase (hero typography: light weight)
// const SubHeading = ({ before, highlight }) => (
//   <h2 className="text-[24px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[30px] lg:text-[34px]">
//     {before}{" "}
//     <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//       {highlight}
//     </span>
//   </h2>
// );

// // Image framed on an offset purple "stage", with a floating status badge
// const ImageStage = ({ src, alt, badge, flip = false }) => (
//   <div className="group relative px-3 pb-6 pt-3 sm:px-4">
//     {/* Offset gradient block behind the image */}
//     <div
//       className={`absolute inset-x-3 bottom-6 top-3 rounded-3xl bg-gradient-to-br from-[#48247f] to-[#702cb0] transition-transform duration-500 sm:inset-x-4 ${
//         flip
//           ? "-translate-x-3 translate-y-3 group-hover:-translate-x-5 group-hover:translate-y-5"
//           : "translate-x-3 translate-y-3 group-hover:translate-x-5 group-hover:translate-y-5"
//       }`}
//     />

//     {/* Image card */}
//     <div className="relative rounded-2xl bg-white p-2 shadow-2xl ring-1 ring-[#48247f]/10 transition-transform duration-500 group-hover:-translate-y-1.5">
//       <img
//         src={src}
//         alt={alt}
//         width="1200"
//         height="800"
//         loading="lazy"
//         decoding="async"
//         className="h-auto w-full rounded-xl border border-[#48247f]/10 object-cover"
//       />
//     </div>

//     {/* Floating status badge */}
    
//   </div>
// );

// const LeadsManagementSection = () => {
//   const reduced = useReducedMotion();
//   const item = reduced ? undefined : fadeUp;
//   const group = reduced ? undefined : stagger;
//   const initial = reduced ? false : "hidden";

//   return (
//     <section
//       id="lead-management"
//       aria-labelledby="lead-management-heading"
//       className="relative isolate w-full overflow-hidden bg-[#f1f5fb] py-14 font-sans text-[#28194f] sm:py-16 lg:py-24"
//     >
//       {/* Cool blue-grey base with purple + teal mesh glows */}
//       <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(60%_50%_at_0%_0%,rgba(112,44,176,0.14),transparent),radial-gradient(50%_45%_at_100%_100%,rgba(18,223,189,0.16),transparent),radial-gradient(40%_35%_at_100%_0%,rgba(72,36,127,0.08),transparent)]" />

//       {/* Fine grid, faded out toward the edges */}
//       <div
//         className="pointer-events-none absolute inset-0 -z-10"
//         style={{
//           backgroundImage:
//             "linear-gradient(#48247f12 1px, transparent 1px), linear-gradient(90deg, #48247f12 1px, transparent 1px)",
//           backgroundSize: "48px 48px",
//           WebkitMaskImage: "radial-gradient(ellipse at center, black 25%, transparent 75%)",
//           maskImage: "radial-gradient(ellipse at center, black 25%, transparent 75%)",
//         }}
//       />

//       {/* Thin gradient line at the top marks the start of a new section */}
//       <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#702cb0]/40 to-transparent" />

//       <div className="mx-auto w-full max-w-[1500px] px-6 sm:px-10 lg:px-14 xl:px-20">
//         {/* ===== Header ===== */}
//         <motion.div
//           initial={initial}
//           whileInView="visible"
//           viewport={{ once: true, margin: "-50px" }}
//           variants={item}
//           className="mx-auto mb-16 max-w-4xl text-center lg:mb-20"
//         >
//           <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
//             <Zap className="h-3.5 w-3.5 text-[#702cb0]" />
//             <span className="uppercase tracking-wide">Intelligent Lead Tracking</span>
//           </div>

//           <h2
//             id="lead-management-heading"
//             className="text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
//           >
//             Accelerate your pipeline and turn leads into{" "}
//             <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
//               loyal clients
//             </span>{" "}
//             with LMSBOTS
//           </h2>

//           <p className="mx-auto mt-5 max-w-[680px] text-[15px] font-normal leading-[1.75] text-[#3b2a63] sm:text-lg">
//             Deploy an enterprise-grade system to capture, track, and nurture
//             prospects effortlessly. Manage your entire sales ecosystem in one
//             centralized dashboard and drive unprecedented conversion rates.
//           </p>

//           <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
//         </motion.div>

//         {/* ===== Row 1: Workflow automation (on white) ===== */}
//         <motion.div
//           initial={initial}
//           whileInView="visible"
//           viewport={{ once: true, margin: "-100px" }}
//           variants={group}
//           className="mb-16 grid items-center gap-12 lg:mb-24 lg:grid-cols-2 lg:gap-16"
//         >
//           <motion.div variants={item} className="order-2 space-y-5 lg:order-1">
//             <Pill icon={GitMerge}>Workflow Automation</Pill>

//             <SubHeading
//               before="Automate your lead nurturing &"
//               highlight="follow-up sequences"
//             />

//             <p className="text-sm font-normal leading-[1.7] text-slate-700 sm:text-base">
//               Eliminate manual data entry and never miss a high-value
//               opportunity. lmsbots systematically automates follow-ups, routes
//               leads to the right agents instantly, and ensures total team
//               alignment.
//             </p>

//             {/* Compact stat cards */}
//             <div className="grid grid-cols-1 gap-3 border-t border-[#48247f]/10 pt-5 sm:grid-cols-2">
//               {STATS.map(({ icon: Icon, title, text }) => (
//                 <div
//                   key={title}
//                   className="group flex items-center gap-3 rounded-xl border border-[#48247f]/10 bg-white p-3 shadow-[0_2px_10px_-6px_rgba(72,36,127,0.18)] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#702cb0]/40 hover:shadow-[0_8px_16px_-8px_rgba(72,36,127,0.28)]"
//                 >
//                   <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white">
//                     <Icon className="h-4 w-4" />
//                   </div>
//                   <div className="min-w-0">
//                     <h3 className="text-sm font-semibold leading-tight text-[#28194f]">
//                       {title}
//                     </h3>
//                     <p className="mt-0.5 text-xs leading-snug text-slate-600">
//                       {text}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </motion.div>

//           <motion.div variants={item} className="order-1 lg:order-2">
//             <ImageStage src={Workflow1} alt="LMSBOTS dashboard showing automated lead follow-up workflows and lead routing" />
//           </motion.div>
//         </motion.div>

//         {/* ===== Row 2: Unified architecture (on a lavender panel) ===== */}
//         <motion.div
//           initial={initial}
//           whileInView="visible"
//           viewport={{ once: true, margin: "-100px" }}
//           variants={group}
//           className="relative overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-white/80 p-5 shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] backdrop-blur-sm sm:rounded-[2rem] sm:p-10 lg:rounded-[3rem] lg:p-14"
//         >
//           <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[#12dfbd]/15 blur-3xl" />

//           <div className="relative grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
//             <motion.div variants={item} className="order-1">
//               <ImageStage
//                 src={Workflow2}
//                 alt="LMSBOTS team collaboration dashboard with real-time sales funnel and performance insights"
//                 flip
//               />
//             </motion.div>

//             <motion.div variants={item} className="order-2 space-y-4">
//               <Pill icon={Settings}>Unified Architecture</Pill>

//               <SubHeading
//                 before="Consolidate your sales operations in a"
//                 highlight="single platform"
//               />

//               <p className="text-sm font-normal leading-[1.7] text-slate-700 sm:text-base">
//                 Replace fragmented tools with a comprehensive command center.
//                 lmsbots provides total visibility into your sales funnel,
//                 enabling data-driven decisions.
//               </p>

//               {/* Compact checklist rows — the 5 sub-cards */}
//               <ul className="space-y-2">
//                 {CHECKLIST.map((text) => (
//                   <li
//                     key={text}
//                     className="flex items-start gap-3 rounded-lg border border-[#48247f]/10 bg-white px-3 py-2.5 shadow-sm transition-all duration-300 hover:translate-x-1 hover:border-[#702cb0]/40 hover:shadow-md"
//                   >
//                     <CheckCircle2
//                       className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#0f9d86]"
//                       strokeWidth={2.5}
//                     />
//                     <span className="text-[13px] font-medium leading-snug text-[#28194f] sm:text-sm">
//                       {text}
//                     </span>
//                   </li>
//                 ))}
//               </ul>
//             </motion.div>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default LeadsManagementSection;







import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import {
  Zap,
  CheckCircle2,
  Clock,
  Activity,
  GitMerge,
  Settings,
} from "lucide-react";

// Images remain untouched
import Workflow1 from "../assets/CrmAutomated.jpeg";
import Workflow2 from "../assets/crmautomated2.jpg";

// Static content lives outside the component so it isn't rebuilt on every render
const STATS = [
  { icon: Clock, title: "Accelerate Response", text: "Engage prospects instantly" },
  { icon: Activity, title: "Maximize ROI", text: "Boost overall conversion rates" },
];

const CHECKLIST = [
  "Omnichannel lead capture and intelligent organization",
  "Automated, performance-based lead routing",
  "Comprehensive interaction logging & journey tracking",
  "Advanced analytics to identify funnel drop-offs",
  "Real-time team collaboration and performance insights",
];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const stagger = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
};

// Small pill used above each sub-heading
const Pill = ({ icon: Icon, children }) => (
  <div className="inline-flex items-center gap-1.5 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-semibold text-[#48247f] shadow-sm">
    <Icon className="h-3 w-3 text-[#702cb0]" />
    {children}
  </div>
);

// Heading with a gradient-highlighted phrase (hero typography: light weight)
const SubHeading = ({ before, highlight }) => (
  <h2 className="text-[24px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[30px] lg:text-[34px]">
    {before}{" "}
    <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
      {highlight}
    </span>
  </h2>
);

// Simple, plain image frame — soft teal block beneath, white padded card
const ImageStage = ({ src, alt }) => (
  <div className="relative mx-auto w-full px-3 pb-6 pt-3 sm:px-4">
    {/* Plain tinted block sits below the image */}
    <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
    <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
      <img
        src={src}
        alt={alt}
        width="1200"
        height="800"
        loading="lazy"
        decoding="async"
        className="h-auto w-full rounded-xl border border-slate-200 object-cover"
      />
    </div>
  </div>
);

const LeadsManagementSection = () => {
  const reduced = useReducedMotion();
  const item = reduced ? undefined : fadeUp;
  const group = reduced ? undefined : stagger;
  const initial = reduced ? false : "hidden";

  return (
    <section
      id="lead-management"
      aria-labelledby="lead-management-heading"
      className="relative isolate w-full overflow-hidden bg-[#f1f5fb] py-14 font-sans text-[#28194f] sm:py-16 lg:py-24"
    >
      {/* Cool blue-grey base with purple + teal mesh glows */}
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(60%_50%_at_0%_0%,rgba(112,44,176,0.14),transparent),radial-gradient(50%_45%_at_100%_100%,rgba(18,223,189,0.16),transparent),radial-gradient(40%_35%_at_100%_0%,rgba(72,36,127,0.08),transparent)]" />

      {/* Fine grid, faded out toward the edges */}
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        style={{
          backgroundImage:
            "linear-gradient(#48247f12 1px, transparent 1px), linear-gradient(90deg, #48247f12 1px, transparent 1px)",
          backgroundSize: "48px 48px",
          WebkitMaskImage: "radial-gradient(ellipse at center, black 25%, transparent 75%)",
          maskImage: "radial-gradient(ellipse at center, black 25%, transparent 75%)",
        }}
      />

      {/* Thin gradient line at the top marks the start of a new section */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#702cb0]/40 to-transparent" />

      <div className="mx-auto w-full max-w-[1500px] px-6 sm:px-10 lg:px-14 xl:px-20">
        {/* ===== Header ===== */}
        <motion.div
          initial={initial}
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          variants={item}
          className="mx-auto mb-16 max-w-4xl text-center lg:mb-20"
        >
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-xs font-medium text-[#48247f] shadow-sm">
            <Zap className="h-3.5 w-3.5 text-[#702cb0]" />
            <span className="uppercase tracking-wide">Intelligent Lead Tracking</span>
          </div>

          <h2
            id="lead-management-heading"
            className="text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
          >
            Accelerate your pipeline and turn leads into{" "}
            <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
              loyal clients
            </span>{" "}
            with LMSBOTS
          </h2>

          <p className="mx-auto mt-5 max-w-[680px] text-[15px] font-normal leading-[1.75] text-[#3b2a63] sm:text-lg">
            Deploy an enterprise-grade system to capture, track, and nurture
            prospects effortlessly. Manage your entire sales ecosystem in one
            centralized dashboard and drive unprecedented conversion rates.
          </p>

          <div className="mx-auto mt-6 h-1 w-24 rounded-full bg-gradient-to-r from-[#12dfbd] via-[#702cb0] to-[#48247f]" />
        </motion.div>

        {/* ===== Row 1: Workflow automation ===== */}
        <motion.div
          initial={initial}
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={group}
          className="mb-16 grid items-center gap-12 lg:mb-24 lg:grid-cols-2 lg:gap-16"
        >
          <motion.div variants={item} className="order-2 space-y-5 lg:order-1">
            <Pill icon={GitMerge}>Workflow Automation</Pill>

            <SubHeading
              before="Automate your lead nurturing &"
              highlight="follow-up sequences"
            />

            <p className="text-sm font-normal leading-[1.7] text-slate-700 sm:text-base">
              Eliminate manual data entry and never miss a high-value
              opportunity. lmsbots systematically automates follow-ups, routes
              leads to the right agents instantly, and ensures total team
              alignment.
            </p>

            {/* Compact stat cards */}
            <div className="grid grid-cols-1 gap-3 border-t border-[#48247f]/10 pt-5 sm:grid-cols-2">
              {STATS.map(({ icon: Icon, title, text }) => (
                <div
                  key={title}
                  className="group flex items-center gap-3 rounded-xl border border-[#48247f]/10 bg-white p-3 shadow-[0_2px_10px_-6px_rgba(72,36,127,0.18)] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#702cb0]/40 hover:shadow-[0_8px_16px_-8px_rgba(72,36,127,0.28)]"
                >
                  <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-[#f1ecfa] text-[#48247f] transition-all duration-300 group-hover:-rotate-6 group-hover:bg-gradient-to-br group-hover:from-[#48247f] group-hover:to-[#702cb0] group-hover:text-white">
                    <Icon className="h-4 w-4" />
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-semibold leading-tight text-[#28194f]">
                      {title}
                    </h3>
                    <p className="mt-0.5 text-xs leading-snug text-slate-600">
                      {text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div variants={item} className="order-1 lg:order-2">
            <ImageStage
              src={Workflow1}
              alt="LMSBOTS dashboard showing automated lead follow-up workflows and lead routing"
            />
          </motion.div>
        </motion.div>

        {/* ===== Row 2: Unified architecture ===== */}
        <motion.div
          initial={initial}
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={group}
          className="relative overflow-hidden rounded-[1.5rem] border border-[#48247f]/10 bg-white/80 p-5 shadow-[0_20px_60px_-20px_rgba(72,36,127,0.25)] backdrop-blur-sm sm:rounded-[2rem] sm:p-10 lg:rounded-[3rem] lg:p-14"
        >
          <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-[#12dfbd]/15 blur-3xl" />

          <div className="relative grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
            <motion.div variants={item} className="order-1">
              <ImageStage
                src={Workflow2}
                alt="LMSBOTS team collaboration dashboard with real-time sales funnel and performance insights"
              />
            </motion.div>

            <motion.div variants={item} className="order-2 space-y-4">
              <Pill icon={Settings}>Unified Architecture</Pill>

              <SubHeading
                before="Consolidate your sales operations in a"
                highlight="single platform"
              />

              <p className="text-sm font-normal leading-[1.7] text-slate-700 sm:text-base">
                Replace fragmented tools with a comprehensive command center.
                lmsbots provides total visibility into your sales funnel,
                enabling data-driven decisions.
              </p>

              {/* Compact checklist rows — the 5 sub-cards */}
              <ul className="space-y-2">
                {CHECKLIST.map((text) => (
                  <li
                    key={text}
                    className="flex items-start gap-3 rounded-lg border border-[#48247f]/10 bg-white px-3 py-2.5 shadow-sm transition-all duration-300 hover:translate-x-1 hover:border-[#702cb0]/40 hover:shadow-md"
                  >
                    <CheckCircle2
                      className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#0f9d86]"
                      strokeWidth={2.5}
                    />
                    <span className="text-[13px] font-medium leading-snug text-[#28194f] sm:text-sm">
                      {text}
                    </span>
                  </li>
                ))}
              </ul>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LeadsManagementSection;